$async({
	"src": "https://js.mollie.com/v1/mollie.js",
	"ref": "mollie"
});